import script from "./swiper.vue?vue&type=script&lang=ts&setup=true"
export * from "./swiper.vue?vue&type=script&lang=ts&setup=true"

import "./swiper.vue?vue&type=style&index=0&id=5343a08c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5343a08c"]])

export default __exports__